module.exports = __webpack_public_path__ + "lendingcircles/resource/App/static/img/financial-coaching.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/financial-coaching.png
// module id = oQiT
// module chunks = 1